import { DateTime } from "@bps/date-time";
import { ClaimEncounterDto } from "@libs/gateways/acc/AccGateway.dtos.ts";
import { Model } from "@libs/models/Model.ts";
import { IRootStore } from "@shared-types/root/root-store.interface.ts";

export class ClaimEncounter extends Model<ClaimEncounterDto> {
  constructor(
    private root: IRootStore,
    dto: ClaimEncounterDto
  ) {
    super(dto);
  }

  get claimId() {
    return this.dto.claimId;
  }

  get encounterId() {
    return this.dto.encounterId;
  }

  get providerId() {
    return this.dto.providerId;
  }

  get businessRole() {
    return this.dto.businessRole;
  }

  get visitDateTime() {
    return DateTime.fromISO(this.dto.visitDateTime);
  }
}
